export default __webpack_public_path__ + "static/media/OPEN2_ICONA.84d0f5a8.svg";